/** Match the movement save's actor/encounter-editor gate. Employee visibility alone grants no movement. */
export function actorMovementPermission(viewerId: unknown, ownerId: unknown, campaignGmId: unknown, primaryRole?: unknown,
  encounterCreatorId?: unknown, canEditEncounter?: unknown): boolean {
  return typeof viewerId === 'string' && viewerId.length > 0
    && (viewerId === ownerId || viewerId === campaignGmId || viewerId === encounterCreatorId
      || primaryRole === 'admin' || primaryRole === 'super_admin' || canEditEncounter === true);
}

export const MOVEMENT_PERMISSION_WARNING = "You don't have permission to move this creature.";

export function movementRefusalMessage(reasons: readonly string[]): string {
  const unique = [...new Set(reasons.map(reason => reason.trim()).filter(Boolean))];
  if (unique.some(reason => /permission|forbidden|unauthorized/i.test(reason))) return MOVEMENT_PERMISSION_WARNING;
  return unique.length ? `Move cancelled. ${unique.join(' ')}` : 'Move cancelled. Your position was restored.';
}
